module.exports = __webpack_public_path__ + "static/media/tomato.eb38960f.jpg";